import Vue from 'vue'

Vue.filter('formatPaymentStatus', function (status) {
  switch (status) {
    case 'paid':
      return 'Pago'
    case 'pending':
      return 'Pendente'
    case 'processing':
      return 'Processando'
    case 'authorized':
      return 'Autorizada'
    case 'refunded':
      return 'Estornado'
    case 'waiting_payment':
      return 'Aguardando pagamento'
    case 'pending_refund':
      return 'Aguardando estorno'
    case 'refused':
      return 'Recusado'
    case 'chargedback':
      return 'Chargeback'
    case 'expired':
      return 'Expirado'
    case 'canceled':
      return 'Cancelado'
  }
})

Vue.filter('formatPaymentMethod', function (method) {
  switch (method) {
    case 'credit_card':
      return 'Cartão de Crédito'
    case 'boleto':
      return 'Boleto Bancário'
    case 'pix':
      return 'PIX'
    default:
      return ''
  }
})

Vue.filter('formatCreditCardBrand', function (brand) {
  return brand.toString().toUpperCase()
})
